import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
export type Listing_Ss_FragmentFragment = { __typename?: 'Listing' } & Pick<
    Types.Listing,
    | 'listingId'
    | 'price'
    | 'priceTitle'
    | 'shortPriceTitle'
    | 'alternativeRentFrequencyLabel'
    | 'title'
    | 'address'
    | 'publishedOnLabel'
    | 'publishedOn'
    | 'availableFrom'
    | 'flag'
    | 'isNewHomesDevelopment'
    | 'isPremium'
    | 'displayType'
    | 'numberOfVideos'
    | 'numberOfViews'
    | 'numberOfImages'
    | 'numberOfFloorPlans'
    | 'FloatOfVideos'
    | 'FloatOfImages'
    | 'FloatOfFloorPlans'
    | 'featuredType'
    | 'section'
    | 'publicationStatus'
    | 'lastPublishedDate'
    | 'propertyType'
    | 'summaryDescription'
> & {
        priceDrop?: Types.Maybe<
            { __typename?: 'PriceDrop' } & Pick<
                Types.PriceDrop,
                'lastPriceChangeDate' | 'percentageChangeLabel'
            >
        >;
        branch?: Types.Maybe<
            { __typename?: 'Branch' } & Pick<
                Types.Branch,
                'branchDetailsUri' | 'branchId' | 'logoUrl' | 'name' | 'phone'
            >
        >;
        tags?: Types.Maybe<
            Array<
                Types.Maybe<{ __typename?: 'Tag' } & Pick<Types.Tag, 'content'>>
            >
        >;
        features?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Feature' } & Pick<
                        Types.Feature,
                        'content' | 'iconId'
                    >
                >
            >
        >;
        image?: Types.Maybe<
            { __typename?: 'Image' } & Pick<Types.Image, 'src' | 'caption'> & {
                    responsiveImgList?: Types.Maybe<
                        Array<
                            Types.Maybe<
                                { __typename?: 'ResponsiveImg' } & Pick<
                                    Types.ResponsiveImg,
                                    'width' | 'src'
                                >
                            >
                        >
                    >;
                }
        >;
        transports?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Transport' } & Pick<
                        Types.Transport,
                        'distanceInMiles' | 'lat' | 'lng' | 'poiType' | 'title'
                    > & {
                            features?: Types.Maybe<
                                { __typename?: 'TransportFeatures' } & Pick<
                                    Types.TransportFeatures,
                                    'tubeLines' | 'zone'
                                >
                            >;
                        }
                >
            >
        >;
        otherPropertyImages?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'SubImage' } & Pick<
                        Types.SubImage,
                        'small' | 'large' | 'caption'
                    >
                >
            >
        >;
        highlights?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Highlight' } & Pick<
                        Types.Highlight,
                        'description' | 'label' | 'url'
                    >
                >
            >
        >;
        listingUris?: Types.Maybe<
            { __typename?: 'ListingUris' } & Pick<
                Types.ListingUris,
                'contact' | 'detail' | 'success'
            >
        >;
        location?: Types.Maybe<
            { __typename?: 'ListingLocation' } & Pick<
                Types.ListingLocation,
                | 'postalCode'
                | 'countryCode'
                | 'county'
                | 'streetName'
                | 'propertyNumberOrName'
                | 'townOrCity'
            > & {
                    coordinates?: Types.Maybe<
                        { __typename?: 'LocationCoordinates' } & Pick<
                            Types.LocationCoordinates,
                            'isApproximate' | 'latitude' | 'longitude'
                        >
                    >;
                }
        >;
    };

export const Listing_Ss_FragmentFragmentDoc = gql`
    fragment LISTING_SS_FRAGMENT on Listing {
        listingId
        price
        priceTitle
        shortPriceTitle
        alternativeRentFrequencyLabel
        priceDrop {
            lastPriceChangeDate
            percentageChangeLabel
        }
        branch {
            branchDetailsUri
            branchId
            logoUrl
            name
            phone
        }
        title
        address
        publishedOnLabel
        publishedOn
        availableFrom
        tags {
            content
        }
        features {
            content
            iconId
        }
        image {
            src
            caption
            responsiveImgList {
                width
                src
            }
        }
        flag
        transports {
            distanceInMiles
            lat
            lng
            poiType
            title
            features {
                tubeLines
                zone
            }
        }
        isNewHomesDevelopment
        isPremium
        otherPropertyImages {
            small
            large
            caption
        }
        highlights {
            description
            label
            url
        }
        displayType
        numberOfVideos
        numberOfViews
        numberOfImages
        numberOfFloorPlans
        FloatOfVideos
        FloatOfImages
        FloatOfFloorPlans
        listingUris {
            contact
            detail
            success
        }
        featuredType
        location {
            coordinates {
                isApproximate
                latitude
                longitude
            }
            postalCode
            countryCode
            county
            streetName
            propertyNumberOrName
            townOrCity
        }
        section
        publicationStatus
        lastPublishedDate
        propertyType
        summaryDescription
    }
`;
